declare const WEBPACK_GIT_REV: string;

import { lazyLoadValuSearch } from "@valu/react-valu-search/loader";

window.addEventListener("DOMContentLoaded", event => {
    lazyLoadValuSearch({
        // This should be the same as customer name in lowercase in valu search manager
        customer: "lahdenkansanopisto",
        // Modify this if needed
        inputSelector: "#valu-search-input",
        openerSelector: ".search-button",
        rev: WEBPACK_GIT_REV,
    });
});
